<mat-form-field [attr.data-test]="'campo-' + dataTest" appearance="fill" class="filter-fill-field hour-select-field"
    [matTooltip]="tooltip" [matTooltipDisabled]="tooltipDisabled">
    <span [attr.data-test]="'texto-' + dataTest">{{ label }}</span>
    <div #box [attr.data-test]="'container-campo-' + dataTest" class="calendar-input">
        <mat-icon [attr.data-test]="'icone-' + dataTest" class="hour-select-icon"
            cdkOverlayOrigin #origin="cdkOverlayOrigin"
            (click)="togglePanel()">schedule</mat-icon>
        <input [attr.data-test]="'campo-input-' + dataTest" matInput [formControl]="control" maxlength="5"
            [placeholder]="placeholder" (input)="onInput($event)">
    </div>
    <mat-error [attr.data-test]="'erro-' + dataTest" *ngIf="errorMessage">{{ errorMessage }}</mat-error>
</mat-form-field>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="panelOpen"
    [cdkConnectedOverlayWidth]="panelWidth"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    (backdropClick)="closePanel()"
    (detach)="closePanel()">
    <div [attr.data-test]="'menu-' + dataTest" class="hour-select-panel">
        <button [attr.data-test]="'opcao-' + dataTest" type="button" class="hour-select-option"
            *ngFor="let time of timeOptions; trackBy: trackByTime" (click)="selectTime(time)">{{ time }}</button>
    </div>
</ng-template>
